import placeholder from '../../../../../assets/images/bg_placeholder_square.svg';
import ImageHelper from '../../../../../utilities/helpers/ImageHelper';
import React, { useState } from 'react';
import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useAccount } from '../../../../../utilities/hooks/UseAccount';
import ProfileImage from '../../../common/ProfileImage.js';
import useClientWidth from '../../../../../utilities/hooks/useClientWidth.js';

const UpcomingAgendaItem = ({ item, onAgendaItemClicked }) => {
	const dictionary = useDictionary();
	const account = useAccount();
	const clientWidth = useClientWidth();

    const getMaxVisibleProfiles = () => {
        if (clientWidth >= 1200) return 10;
        if (clientWidth < 1200 && clientWidth > 986) return 2;
        if (clientWidth >= 448) return 5;
        return 3;
    };

	const isResource = Object.prototype.hasOwnProperty.call(item, 'experiences');

	const handleUpcomingBookingClick = (id) => {
		onAgendaItemClicked(id, isResource ? 'resource' : 'experience');
	};

	const formatDate = () => {
		let formatted = '';
		let date = moment();
		let start = moment(item.start_time * 1000);
		let end = moment(item.end_time * 1000);

		let dayDiff = date.dayOfYear() - start.dayOfYear();

		if (dayDiff === 0) {
			formatted = dictionary.today;
		} else if (dayDiff === 1) {
			formatted = dictionary.tomorrow;
		} else {
			formatted = start.format('MMM D, YYYY');
		}

		formatted +=
			' · ' +
			start.format('H:mm') +
			(item.end_time ? ' - ' + end.format('H:mm') : '');

		return formatted;
	};

	const getParticipants = () => {
		if (isResource) {
			let sum = 0;
			item.bookings.map((booking) =>
				booking.participant_groups.map((group) => (sum += group.quantity))
			);

			return sum.toString();
		} else {
			return item?.booked + '/' + item?.capacity;
		}
		//return (item?.participant_groups.length > 0 ? item?.participant_groups?.reduce((x, y) => x + y.quantity, 0,) : '0') + '/' + item?.slot?.capacity
	};

	const getImage = () => {
		let imageUrl = '';
		let color = '';
		if (isResource) {
			imageUrl = item?.experiences[0]?.assets?.thumbnail_url;
			color = item?.experiences[0]?.color;
		} else {
			imageUrl = item?.experience?.thumbnail_url;
			color = item.experience.color;
		}

		return (
			<div
				className="experience-thumbs-container home-thumbs-container"
				style={{ height: 'unset', margin:'8px 0px 8px 8px', ...(clientWidth > 986 && {width:'unset'}) }}
			>
				<img
					className="experience-thumb home-thumb"
					style={{ height: '104px', width: '88px' }}
					onError={(e) => {
						e.currentTarget.src = placeholder;
						e.currentTarget.style.padding = '10px';
					}}
					src={imageUrl ? ImageHelper.getFullImageUrl(imageUrl) : null}
				/>
				<div
					className="experience-thumb-color-line"
					style={{ background: color }}
				/>
			</div>
		);
	};

	const getTitle = () => {
		if (isResource) {
			return item?.bookings?.map((item) => (
				<h4
					key={item?.experience?.id}
					style={{ fontWeight: 'normal', fontSize: '13px' }}
					className='truncate'
					title={item?.experience?.title}
				>
					{item?.experience?.title}
				</h4>
			));
		} else {
			return (
				<h4 style={{ fontWeight: 'normal', fontSize: '13px' }} className='truncate' title={item?.experience?.title}>
					{item?.experience?.title}
				</h4>
			);
		}
	};

	const bothImageAndTitle = () => {
		return (
			<>
				{getImage()}

				<div
					className="experience-item-basic-info-container home-item-basic-info-container"
					style={{ gap: '8px' }}
				>
					<div>
						<h4 title={formatDate()} className='mb-8px fs-14px fw-500 truncate'>{formatDate()}</h4>
						{getTitle()}
					</div>
					{
						account && (
							<div className='d-flex items-center' style={{gap: '8px'}}>
								<ProfileImage photo={account?.profile_photo?.path} name={`${account?.first_name} ${account?.last_name}`} size={{ width: 24, height: 24,fontSize: 11, lineHeight: 14 }} styleObject={{ minWidth:'24px' }}/>
								<h4 style={{ fontWeight: 'normal', fontSize: '12px' }} className='truncate'>
									{`${account?.first_name} ${account?.last_name}`}
								</h4>
							</div>
						)
					}
				</div>
			</>
		)
	}

	const participantGroups = () => {
		const participants = item.participants || [];
		const totalParticipants = participants.length;
		return (
			<>
				{totalParticipants > 0 && (
					<div className="d-flex">
						{participants
							.slice(0, getMaxVisibleProfiles())
							.map((participant, index) => (
								<ProfileImage
									key={index}
									size={{ width: 24, height: 24, fontSize: 11, lineHeight: 14 }}
									styleObject={index > 0 ? { marginLeft: '-4px' } : {}}
									name={participant.name}
									isDefaultUser={true}
									isBorder={true}
								/>
							))}
						{totalParticipants > getMaxVisibleProfiles() && (
							<div className="d-flex items-center justify-center home-participants-count-wrapper">
								<span className="home-participants-count font-family-roboto">
									+{totalParticipants - getMaxVisibleProfiles()}
								</span>
							</div>
						)}
					</div>
				)}
			</>
		);
	};

	return (
		<div
			key={item.id}
			className={`experience-item-full-container home-item-full-container`}
			onClick={() =>
				handleUpcomingBookingClick(item.id)
			}
			style={{
				marginLeft: 'unset',
				marginRight: 'unset',
				cursor: 'pointer'
			}}
		>
			{
				clientWidth > 767
				? (
					<>
						{bothImageAndTitle()}
					</>
				) 
				: (
					<div className='d-flex'>
						{bothImageAndTitle()}
					</div>
				)
			}

			<div className="home-item-divider" />
			<div
				className="experience-item-basic-info-container home-item-basic-info-container home-item-participants-container"
				style={{ gap: clientWidth > 768 ? '8px' : '16px' }}
			>
				{!item.addons && (
					<>
						<div style={{ display: 'flex', gap: '8px' }}>
							<div className='d-flex home-participants-container items-center'>
								<h4 style={{fontWeight: 'normal', width: clientWidth > 986 ? '100%' : 'unset'}}>{dictionary.participants}</h4>
								<h4 style={{ fontWeight: 'normal', opacity: '0.6' }}>
									{getParticipants()}
								</h4>
							</div>
						</div>
						{participantGroups()}
					</>
				)}
				{item.addons && (
					<>
						<div style={{ display: 'flex', gap: '8px' }}>
							<div className='d-flex home-participants-container items-center'>
								<h4 style={{fontWeight: 'normal'}}>{dictionary.participants}</h4>
								<h4 style={{ fontWeight: 'normal', opacity: '0.6' }}>
									{getParticipants()}
								</h4>
							</div>
							{participantGroups()}
						</div>
						<div style={{ display: 'flex', gap: '8px' }}>
							<div className='d-flex items-center w-full'>
								<h4 style={{fontWeight: 'normal'}}>{'addons'}</h4>
								<h4 style={{ fontWeight: 'normal', opacity: '0.6', marginLeft: '4px' }}>
									{0}
								</h4>
							</div>
						</div>
					</>
				)}
				{item.booked <= 0 ? (
					<h4
						style={{
							color: 'rgba(34, 38, 76, 0.6)',
							fontWeight: 'normal'
						}}
						data-testid="no-bookings-yet"
					>
						{dictionary.no_bookings_for_slot_yet}
					</h4>
				) : null}
			</div>
		</div>
	);
};

UpcomingAgendaItem.propTypes = {
	item: PropTypes.object.isRequired,
	onAgendaItemClicked: PropTypes.func.isRequired
};

export default UpcomingAgendaItem;
